import { Button, Form, Input, message, Select } from 'antd';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useUserContext } from 'features/users';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


type props = {
    closeModal: () => void;
    isOpen: boolean;
    refetch: () => void;
};

export const ClosingReportModal = ({
    closeModal,
    isOpen,
    refetch
}: props) => {
    const { user } = useUserContext();
    const userHasAccessToEventList: any = user?.user_id != 107093;

    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm();
    const { t } = useTranslation();

    const [loading, setLoading] = useState<boolean>(false);


    const handleClose = () => {
        form.resetFields();
        closeModal();
    };

    const onFinish = (formValues: any) => {
        handleExport(formValues);
    };

    const handleExport = async (values: {
        event_name?: any;
        category_names?: any;
        transaction_status?: any;
        file_name?: any;
        Date_From?: any;
        Date_To?: any;
    }) => {
        setLoading(true);


        try {
            const params = {
                event_id: values.event_name,
                // cat_id: values.category_names,
                // transaction_status: values.transaction_status,
                FileName: values.file_name,
                // start_date: values.Date_From && payFormatDate(values.Date_From),
                // end_date: values.Date_To && payFormatDate(values.Date_To),
                type: "ClosingReport",
            };

            const response = await TransectionApiServices().exportFinancialRequest(params);

            if (response.ResponseStatus === 1) {
                setLoading(false);
                refetch();
                handleClose();

            } else {
                message.error(response.ResponseMessage);
            }
        } catch (error) {
            message.error("File doesn't contain valid data");
            setLoading(false);
        }
        finally {
            setLoading(false);
        }

    };


    const [event, setEvent] = useState({
        items: []
    })

    const getEvent = async () => {
        try {
            const apires = await TransectionApiServices().getDropDownList(`Flag=${'Events'}`)
            setEvent(apires as any)
        } catch (error) {
            message.error('')
        }
    }


    useEffect(() => {
        if (isOpen) {
            getEvent();
            form.setFieldValue("transaction_status", "all");

        }

    }, [isOpen, form])




    return (
        <div className='popup'>
            <div className='modal_head'>
                <h4>Closing Report Export</h4>
                <button onClick={handleClose} className='close-btn'>
                    &times;
                </button>

            </div>
            <div className='modal_body'>
                <Form
                    // id={formId}
                    // name={formId}
                    className='filters-form'
                    form={form}
                    layout='vertical'
                    onFinish={onFinish}
                    // initialValues={initialValues}
                    onFinishFailed={() => {
                        setValidateTrigger(['onChange']);
                    }}
                    validateTrigger={validateTrigger}
                >
                    {/* <ContentFilters.FormItemsWrapper> */}
                    <FormSectionsSeparator title={""}>


                        <Form.Item
                            // label={t('shops.formfield.fieldName.label')}
                            label={'Event Name'}
                            name={"event_name"}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                options={event?.items?.filter((res: any) => (res.Id === 732 && !userHasAccessToEventList) || (res.Id === res.Id && userHasAccessToEventList)).map((res: any) => ({ label: res.Text, value: res.Id }))}
                                placeholder={"Select Event Name"}

                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                        <Form.Item
                            // label={t('shops.formfield.fieldName.label')}
                            label={'File Name'}
                            name={"file_name"}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <Input placeholder={'Enter File Name'} />
                        </Form.Item>

                    </FormSectionsSeparator>


                    <Button type='primary' htmlType='submit' loading={loading}>
                        Generate Report
                    </Button>



                </Form>

            </div>
        </div>
    );
};



